module.exports = __webpack_public_path__ + "56f804f2a22627cdaaeff3ee151cb283.svg";